import apiClient from './client';
import { API_PATHS } from '../utils/constants';

function unwrapResponsePayload(responseData) {
  return responseData?.data ?? responseData;
}

function extractItems(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

function extractTotal(payload, items) {
  if (!payload || Array.isArray(payload)) return items.length;
  return payload?.pagination?.total || payload?.meta?.total || payload?.total || items.length;
}

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || value === 'all') return;
    params.set(key, String(value));
  });
  return params.toString();
}

export async function listPublicAnnouncements(filters = {}) {
  const query = buildQuery(filters);
  const endpoint = query
    ? `${API_PATHS.announcements.publicBase}?${query}`
    : API_PATHS.announcements.publicBase;
  const { data } = await apiClient.get(endpoint);
  return extractItems(unwrapResponsePayload(data));
}

export async function getPublicAnnouncementByIdentifier(identifier) {
  const { data } = await apiClient.get(
    `${API_PATHS.announcements.publicBase}/${encodeURIComponent(String(identifier))}`,
  );
  return unwrapResponsePayload(data);
}

export async function listAdminAnnouncements(filters = {}) {
  const query = buildQuery(filters);
  const endpoint = query
    ? `${API_PATHS.announcements.adminBase}?${query}`
    : API_PATHS.announcements.adminBase;
  const { data } = await apiClient.get(endpoint);
  const payload = unwrapResponsePayload(data);
  const items = extractItems(payload);
  return { items, total: extractTotal(payload, items) };
}

export async function getAdminAnnouncementByIdentifier(identifier) {
  const { data } = await apiClient.get(
    `${API_PATHS.announcements.adminBase}/${encodeURIComponent(String(identifier))}`,
  );
  return unwrapResponsePayload(data);
}

export async function createAnnouncement(payload) {
  const { data } = await apiClient.post(API_PATHS.announcements.adminBase, payload);
  return unwrapResponsePayload(data);
}

export async function updateAnnouncement(identifier, payload) {
  const { data } = await apiClient.patch(
    `${API_PATHS.announcements.adminBase}/${encodeURIComponent(String(identifier))}`,
    payload,
  );
  return unwrapResponsePayload(data);
}

export async function publishAnnouncement(identifier) {
  const { data } = await apiClient.post(
    `${API_PATHS.announcements.adminBase}/${encodeURIComponent(String(identifier))}/publish`,
  );
  return unwrapResponsePayload(data);
}

export async function unpublishAnnouncement(identifier) {
  const { data } = await apiClient.post(
    `${API_PATHS.announcements.adminBase}/${encodeURIComponent(String(identifier))}/unpublish`,
  );
  return unwrapResponsePayload(data);
}

export async function archiveAnnouncement(identifier) {
  const { data } = await apiClient.post(
    `${API_PATHS.announcements.adminBase}/${encodeURIComponent(String(identifier))}/archive`,
  );
  return unwrapResponsePayload(data);
}

export async function deleteAnnouncement(identifier) {
  const { data } = await apiClient.delete(
    `${API_PATHS.announcements.adminBase}/${encodeURIComponent(String(identifier))}`,
  );
  return unwrapResponsePayload(data);
}
